import React from "react";
import { Table, ConfigProvider } from "antd";
import { Colors } from "../../config";

import "./styles.css";
const DefaultTable = ({
  borderradius = 12,
  columns = [],
  data = [],
  bordered = true,
  pagination = false,
  cursornormal = false,
  horizontal = 1500,
  ...props
}) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Table: {
            headerBg: Colors.main,
            headerBorderRadius: borderradius,
            headerColor: "white",
          },
        },
      }}
    >
      <Table
        columns={columns}
        dataSource={data}
        bordered={bordered}
        pagination={pagination}
        scroll={{ x: horizontal }}
        className="default-table"
        rowClassName={(record, index) =>
          index % 2 !== 0
            ? `even-row ${!cursornormal && "cursor-pointer"} text-[0.875em]`
            : `odd-row ${!cursornormal && "cursor-pointer"} text-[0.875em]`
        }
        {...props}
      />
    </ConfigProvider>
  );
};

export default DefaultTable;
